import type { PaymentMethodsConfiguration } from '@adyen/adyen-web/dist/types/core/types';
import { type CreateApplePayConfigProps, createApplePayConfig } from './applepay';
import { type CreateCardConfigProps, createCardConfig } from './card';
import { type CreateGiftCardConfigProps, createGiftCardConfig } from './giftcard';
import { type CreateGooglePayConfigProps, createGooglePayConfig } from './googlepay';
import { type CreateIDealConfigProps, createIDealConfig } from './ideal';
import { type CreateKlarnaConfigProps, createKlarnaConfig } from './klarna';
import { type CreateKlarnaAccountConfigProps, createKlarnaAccountConfig } from './klarna-account';
import { type CreateKlarnaPayNowConfigProps, createKlarnaPayNowConfig } from './klarna-paynow';
import { type CreateMBWayConfigProps, createMBWayConfig } from './mbway';
import { type CreateMobilePayConfigProps, createMobilePayConfig } from './mobilepay';
import { type CreateOnlineBankingPLConfigProps, createOnlineBankingPLConfig } from './online-banking-pl';
import { type CreatePayPalConfigProps, createPayPalConfig } from './paypal';
import { type CreateTwintConfigProps, createTwintConfig } from './twint';

export type CreatePaymentMethodsConfigProps = CreateCardConfigProps &
  CreatePayPalConfigProps &
  CreateGooglePayConfigProps &
  CreateApplePayConfigProps &
  CreateKlarnaConfigProps &
  CreateKlarnaAccountConfigProps &
  CreateKlarnaPayNowConfigProps &
  CreateGiftCardConfigProps &
  CreateIDealConfigProps &
  CreateMBWayConfigProps &
  CreateMobilePayConfigProps &
  CreateOnlineBankingPLConfigProps &
  CreateTwintConfigProps;

export const createPaymentMethodsConfig = ({
  locale,
  miniCart,
  cartId,
  baseUrl,
  isGiftCardEnough,
  isGiftCardRemoved,
  paymentData,
  setIsPaymentBtnDisabled,
  setPaymentInProgress,
  setIsGiftCardEnough,
  setIsErrorGiftCardInput,
  setCanPayWithGiftCards,
  setOnErrorGiftCard,
  setPaymentError,
  setGiftCardOrder,
  getCartAddresses,
  placeOrderMutation,
  resolveData,
  validateDiscountsBeforePayment,
  onBeforeSubmit,
}: CreatePaymentMethodsConfigProps): PaymentMethodsConfiguration => ({
  card: createCardConfig({
    paymentData,
    setIsPaymentBtnDisabled,
    setPaymentInProgress,
    placeOrderMutation,
    setPaymentError,
    resolveData,
  }),
  paypal: createPayPalConfig({
    locale,
    miniCart,
    cartId,
    baseUrl,
    setIsPaymentBtnDisabled,
    setPaymentInProgress,
    setPaymentError,
    validateDiscountsBeforePayment,
    placeOrderMutation,
    onBeforeSubmit,
  }),
  googlepay: createGooglePayConfig({
    miniCart,
    cartId,
    baseUrl,
    setIsPaymentBtnDisabled,
    setPaymentInProgress,
    setPaymentError,
    validateDiscountsBeforePayment,
    placeOrderMutation,
    resolveData,
  }),
  applepay: createApplePayConfig({
    locale,
    paymentData,
    miniCart,
    cartId,
    baseUrl,
    setIsPaymentBtnDisabled,
    setPaymentInProgress,
    setPaymentError,
    validateDiscountsBeforePayment,
    placeOrderMutation,
    onBeforeSubmit,
  }),
  klarna: createKlarnaConfig({
    setIsPaymentBtnDisabled,
    setPaymentInProgress,
    setPaymentError,
    placeOrderMutation,
    resolveData,
  }),
  klarna_account: createKlarnaAccountConfig({
    setIsPaymentBtnDisabled,
    setPaymentInProgress,
    setPaymentError,
    placeOrderMutation,
    resolveData,
  }),
  klarna_paynow: createKlarnaPayNowConfig({
    setIsPaymentBtnDisabled,
    setPaymentInProgress,
    setPaymentError,
    placeOrderMutation,
    resolveData,
  }),
  giftcard: createGiftCardConfig({
    isGiftCardEnough,
    isGiftCardRemoved,
    setIsPaymentBtnDisabled,
    setPaymentInProgress,
    setPaymentError,
    setIsGiftCardEnough,
    setIsErrorGiftCardInput,
    setCanPayWithGiftCards,
    setOnErrorGiftCard,
    placeOrderMutation,
    setGiftCardOrder,
    getCartAddresses,
  }),
  ideal: createIDealConfig({
    setIsPaymentBtnDisabled,
    setPaymentInProgress,
    setPaymentError,
    placeOrderMutation,
    onBeforeSubmit,
  }),
  mbway: createMBWayConfig({
    setIsPaymentBtnDisabled,
    setPaymentInProgress,
    setPaymentError,
    placeOrderMutation,
    onBeforeSubmit,
  }),
  mobilepay: createMobilePayConfig({
    setIsPaymentBtnDisabled,
    setPaymentInProgress,
    setPaymentError,
    placeOrderMutation,
    onBeforeSubmit,
  }),
  onlineBanking_PL: createOnlineBankingPLConfig({
    setIsPaymentBtnDisabled,
    setPaymentInProgress,
    setPaymentError,
    placeOrderMutation,
    onBeforeSubmit,
  }),
  twint: createTwintConfig({
    setIsPaymentBtnDisabled,
    setPaymentInProgress,
    setPaymentError,
    placeOrderMutation,
    onBeforeSubmit,
  }),
});
